<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :loading="loading" rounded text :icon="small" @click="rechnungVersenden(rechnung)">
        <v-icon v-if="icon">{{ icon }}</v-icon>
        <span v-if="text">{{ text }}</span>
      </v-btn>
    </template>
    <span>Rechnung per Mail senden</span>
  </v-tooltip>
</template>

<script>
  import { generatePDFRechnungToLink } from '@/funktionen/generatePDFRechnungToLink.js'
  export default {
    props: ['small', 'icon', 'text', 'rechnung'],
    data () {
      return {
        loading: false
      }
    },
    computed: {
      //
    },
    methods: {
      async rechnungVersenden (rechnung) {
        console.log(rechnung)
        this.loading = true
        try {
          const kasse = this.$store.getters['einstellungen/einstellung']('kassen')[rechnung.kasse]
          const year = rechnung.rechnungsnummer.split('-')[0]
          const storagePath = `rechnungen/${this.$vars.verbindung}/${year}/${rechnung.rechnungsnummer}`
          const file = await this.$firebase.functions().httpsCallable('existsPDF')({ path: storagePath, rechnung, kasse, verein: this.$vars.verbindung })
          if (!file.data) {
            // this.createPDF.gesamt++
            const bbr = this.$store.getters['bbrbbr/bbr'](rechnung.bbrID)
            const settings = this.$store.getters['einstellungen/einstellung']('allgemein')
            await generatePDFRechnungToLink(rechnung, kasse, bbr, settings, this.$vars.verbindung)
            // this.createPDF.erledigt++
          }
          const result = await this.$firebase.functions().httpsCallable('sendRechnungen')({
            rechnungen: [rechnung],
            verein: this.$vars.verbindung
          })
          console.log(result)
          if (result.data[0].error) {
            console.log('error')
            throw new Error(`Unbekannter Fehler.`)
          } else {
            this.$store.state.snackbar = {
              show: true,
              nachricht: 'Rechnung wurde gesendet!'
            }
          }
        } catch (error) {
          console.log(error)
          this.$store.state.snackbar = {
            show: true,
            nachricht: 'Fehler beim Versenden der Rechnung:' + error
          }
        }
        this.loading = false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// rechnungSenden.vue?3d27017f